// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Apply from "../Control.Apply/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
var map = /* #__PURE__ */ Data_Functor.map(Specular_FRP_Base.functorDynamic);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var lift2 = /* #__PURE__ */ Control_Apply.lift2(Specular_FRP_Base.applyDynamic);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var mapFlipped = /* #__PURE__ */ Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var Ref = /* #__PURE__ */ (function () {
    function Ref(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Ref.create = function (value0) {
        return function (value1) {
            return new Ref(value0, value1);
        };
    };
    return Ref;
})();
var value = function (v) {
    return v.value0;
};
var refValue = value;
var read = function (dictMonadEffect) {
    var readDynamic1 = Specular_FRP_Base.readDynamic(dictMonadEffect);
    return function (v) {
        return readDynamic1(v.value0);
    };
};
var readRef = function (dictMonadEffect) {
    return read(dictMonadEffect);
};
var pureFocusRef = function (lens) {
    return function (v) {
        return new Ref(map(lens.get)(v.value0), function ($94) {
            return v.value1((function (modify_a) {
                return function (s) {
                    return lens.set(s)(modify_a(lens.get(s)));
                };
            })($94));
        });
    };
};
var previewRef = function (prism) {
    return function (v) {
        return new Ref(map(prism.preview)(v.value0), function ($95) {
            return v.value1((function (modify_a) {
                return function (s) {
                    var v1 = modify_a(prism.preview(s));
                    if (v1 instanceof Data_Maybe.Just) {
                        return prism.review(v1.value0);
                    };
                    return s;
                };
            })($95));
        });
    };
};
var newWithEvent = function (dictMonadFRP) {
    var MonadCleanup1 = dictMonadFRP.MonadCleanup1();
    var Monad0 = MonadCleanup1.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind1 = Control_Bind.bind(Bind1);
    var MonadEffect0 = dictMonadFRP.MonadEffect0();
    var newDynamic = Specular_FRP_Base.newDynamic(MonadEffect0);
    var discard1 = discard(Bind1);
    var subscribeEvent_ = Specular_FRP_Base.subscribeEvent_(MonadEffect0)(MonadCleanup1);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (initial) {
        return function (extraUpdate) {
            return bind1(newDynamic(initial))(function (v) {
                return discard1(subscribeEvent_(v.modify)(extraUpdate))(function () {
                    return pure2(new Ref(v.dynamic, v.modify));
                });
            });
        };
    };
};
var newRefWithEvent = function (dictMonadFRP) {
    return newWithEvent(dictMonadFRP);
};
var $$new = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var bind1 = Control_Bind.bind(Monad0.Bind1());
    var newDynamic = Specular_FRP_Base.newDynamic(dictMonadEffect);
    var pure2 = Control_Applicative.pure(Monad0.Applicative0());
    return function (initial) {
        return bind1(newDynamic(initial))(function (v) {
            return pure2(new Ref(v.dynamic, v.modify));
        });
    };
};
var newRef = function (dictMonadEffect) {
    return $$new(dictMonadEffect);
};
var modify = function (dictMonadEffect) {
    var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
    return function (v) {
        return function ($96) {
            return liftEffect(v.value1($96));
        };
    };
};
var refUpdate = function (dictMonadEffect) {
    return modify(dictMonadEffect);
};
var write = function (dictMonadEffect) {
    var modify1 = modify(dictMonadEffect);
    return function (r) {
        var $97 = modify1(r);
        return function ($98) {
            return $97((function (new_) {
                return function (_old) {
                    return new_;
                };
            })($98));
        };
    };
};
var refUpdateConst = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var set = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var updateRef = function (dictMonadEffect) {
    return write(dictMonadEffect);
};
var invariantRef = {
    imap: function (f) {
        return function (g) {
            return function (v) {
                return new Ref(map(f)(v.value0), function ($99) {
                    return v.value1((function (h) {
                        return function ($100) {
                            return g(h(f($100)));
                        };
                    })($99));
                });
            };
        };
    }
};
var focusRef = function (lensD) {
    return function (v) {
        return new Ref(lift2(function (v1) {
            return v1.get;
        })(lensD)(v.value0), function (x) {
            return function __do() {
                var f = readDynamic(mapFlipped(lensD)(function (lens) {
                    return function (modify_a) {
                        return function (s) {
                            return lens.set(s)(modify_a(lens.get(s)));
                        };
                    };
                }))();
                return v.value1(f(x))();
            };
        });
    };
};
var $$const = function (x) {
    return new Ref(pure(x), Data_Function["const"](pure1(Data_Unit.unit)));
};
var constRef = $$const;
export {
    Ref,
    $$new as new,
    newWithEvent,
    $$const as const,
    value,
    modify,
    read,
    write,
    focusRef,
    pureFocusRef,
    previewRef,
    newRef,
    newRefWithEvent,
    constRef,
    readRef,
    updateRef,
    set,
    refUpdateConst,
    refValue,
    refUpdate,
    invariantRef
};
